import { match } from 'ts-pattern';
import { IBillingUnitEntity } from '../../entitites/common/billing-unit.entity';

export class BillingUnitDto {
  readonly interval:
    | 'monthly'
    | 'yearly'
    | 'half-yearly'
    | 'quarterly'
    | 'mixed';
  readonly label: string;
  readonly abbreviation: string;

  constructor(billingUnitEntity: IBillingUnitEntity['billing_unit']) {
    this.interval = billingUnitEntity;

    const { label, abbreviation } = BillingUnitDto.getLabels(billingUnitEntity);
    this.label = label;
    this.abbreviation = abbreviation;
  }

  private static getLabels(interval: IBillingUnitEntity['billing_unit']): {
    label: string;
    abbreviation: string;
  } {
    return match(interval)
      .returnType<{ label: string; abbreviation: string }>()
      .with('monthly', () => ({
        label: 'per maand',
        abbreviation: 'p.m.',
      }))
      .with('quarterly', () => ({
        label: 'per kwartaal',
        abbreviation: 'p.k.',
      }))
      .with('half-yearly', () => ({
        label: 'per half jaar',
        abbreviation: 'p.h.j.',
      }))
      .with('yearly', () => ({
        label: 'per jaar',
        abbreviation: 'p.j.',
      }))
      .with('mixed', () => ({
        label: 'verdeeld over meerdere termijnen',
        abbreviation: 'gemengd',
      }))
      .exhaustive();
  }
}
